import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { NETWORK_ERROR_CODES } from "../constants/errorCodes";

export interface NetworkErrorOptions {
  message: string;
  url?: string;
  method?: string;
  statusCode?: number;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown for network-related issues
 */
export class NetworkError extends BaseError {
  public readonly url?: string;
  public readonly method?: string;
  public readonly networkStatusCode?: number;

  constructor(options: NetworkErrorOptions) {
    super({
      message: options.message,
      category: "network",
      severity: "high",
      statusCode: options.statusCode ?? 502,
      code: options.code ?? NETWORK_ERROR_CODES.NETWORK_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: false,
      reportable: true,
    });

    this.url = options.url;
    this.method = options.method;
    this.networkStatusCode = options.statusCode;
  }
}
